import { CardElement } from '@stripe/react-stripe-js';
import { type StripeCardElementChangeEvent } from '@stripe/stripe-js';
import { type FC } from 'react';

const STRIPE_ELEMENT_OPTIONS = {
  style: {
    base: {
      lineHeight: '1.5rem',
      fontSize: '16px',
      color: '#000000',
      letterSpacing: 'normal',
    },
    invalid: {
      color: '#EF1212',
    },
  },
};

interface StripeCardElementProps {
  onChange: (event: StripeCardElementChangeEvent) => void;
}

export const StripeCardElement: FC<StripeCardElementProps> = ({ onChange }) => {
  return (
    <CardElement
      className="form-input mt-2 w-full rounded-lg border border-leland-gray-stroke"
      id="stripe-card-element"
      options={STRIPE_ELEMENT_OPTIONS}
      onChange={onChange}
    />
  );
};
